import { cn } from '@/lib/utils'
import { cva, type VariantProps } from 'class-variance-authority'
import { forwardRef } from 'react'

const tagThumbnailVariants = cva(
  'text-center rounded-full p-2 pt-[9px] w-fit font-bold uppercase text-light text-xs leading-[8px] flex items-center gap-1',
  {
    variants: {
      variant: {
        primary: 'bg-primary',
        secondary: 'bg-secondary',
        neutral: 'bg-neutral-900 text-light',
        light: 'bg-light text-neutral-900',
      },
      size: {
        default: 'h-[25px]',
        small: 'h-[19px] leading-[7px] text-[10px] py-1.5 px-2',
      },
    },

    defaultVariants: {
      variant: 'primary',
      size: 'default',
    },
  }
)

export type TagThumbnailProps = VariantProps<typeof tagThumbnailVariants> & {
  className?: string
  title?: React.ReactNode
  icon?: React.ReactNode
}

const TagThumbnail = forwardRef<HTMLDivElement, TagThumbnailProps>(
  ({ className, variant, title, icon, size, ...props }, ref) => {
    return (
      <span
        ref={ref}
        className={cn(tagThumbnailVariants({ variant, size }), className)}
        {...props}
      >
        {icon} {title}
      </span>
    )
  }
)

TagThumbnail.displayName = 'Tag'

export { TagThumbnail }
